import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useId, useRef } from 'react';
import $ from 'jquery';
import Select2Forms from '../../../../js/components/select';
import FieldSelect from '../../../components/FieldSelect';
import Spinner from '../../../components/Spinner';
import useLatestRef from '../../../hooks/useLatestRef';
export default function SelectField({ label, value, onChange, disabled, loading = false, options }) {
    const id = useId();
    const selectRef = useRef(null);
    const onChangeRef = useRef(onChange);
    const optionsRef = useLatestRef(options);
    const showCheckmark = !loading && Boolean(value);
    useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    useEffect(() => {
        const select = selectRef.current;
        if (!select)
            return undefined;
        const $select = $(select);
        const failedLogos = new Set();
        const renderOption = (option) => {
            const logo = optionsRef.current.find(item => item.id === String(option.id))?.logo;
            if (!logo || failedLogos.has(logo))
                return option.text;
            const $content = $('<span>').addClass('d-inline-flex align-items-center mw-100');
            const $image = $('<img>').attr({ src: logo, alt: option.text }).addClass('opc-select-logo');
            $image.on('error', () => {
                failedLogos.add(logo);
                $content.text(option.text);
            });
            return $content.append($image);
        };
        Select2Forms.init($select.parent(), { templateSelection: renderOption, templateResult: renderOption });
        const onSelect = () => onChangeRef.current(String($select.val() || ''));
        $select.on('select2:select.opc select2:unselect.opc', onSelect);
        return () => {
            $select.off('.opc');
            if ($select.data('select2'))
                $select.select2('destroy');
        };
    }, [optionsRef]);
    useEffect(() => {
        const select = selectRef.current;
        if (!select)
            return;
        const $select = $(select);
        $select.val(value).trigger('change');
    }, [value, disabled, options]);
    return (_jsx("div", { className: "form-group position-relative mt-4", children: _jsxs("div", { className: `form-floating opc-select-wrap position-relative${loading ? ' opc-select-wrap-loading' : ''}${showCheckmark ? ' opc-select-wrap-success' : ''}`, children: [_jsxs("label", { className: "bg-light", htmlFor: id, children: [label, " *"] }), _jsx(FieldSelect, { ref: selectRef, id: id, className: "custom-select select2-hidden-accessible border-dark", "data-placeholder": label, "data-parent-selector": ".opc-panel", value: value, required: true, disabled: disabled, onChange: event => onChange(event.target.value), placeholder: `${label} *`, options: options.map(option => ({ value: option.id, label: option.name, disabled: option.disabled })) }), loading && _jsx(Spinner, { size: "sm", className: "opc-select-loading position-absolute", label: label }), showCheckmark && _jsx("span", { className: "opc-select-checkmark position-absolute rounded-circle", "aria-hidden": "true" })] }) }));
}
